import {
  HomeHospitalItem,
  HomeHospitalResponseItem
} from '@/types/HomeHospital'

export function convertHomeHospitalItem(
  data: HomeHospitalResponseItem
): HomeHospitalItem {
  const caseScore = data.cases_num ? Number(data.cases_num) : undefined
  const instructorScore = data.instructors_num
    ? Number(data.instructors_num)
    : undefined
  const salaryScore = data.salary ? Number(data.salary) : undefined
  const magnificationScore = data.magnification
    ? Number(data.magnification)
    : undefined

  return {
    imageSrc: data.basicinfo_image1 ? `${data.basicinfo_image1}` : undefined,
    name: `${data.hospital_name}`,
    prefecture: `${data.prefectures}`,
    address: `${data.hospital_address}`,
    hospitalClass: `${data.hospital_class}`,
    bedCount: Number(data.bed_num),
    doctorCount: Number(data.doctor_num),
    paidFlg: Number(data.paid_flg),
    activeFlg: Number(data.active_flg),
    id: Number(data.hospital_id),
    discerningConditions: data.discerning_conditions,
    juniorCount: data.junior ? Number(data.junior) : undefined,
    specialistCount: data.specialist ? Number(data.specialist) : undefined,
    publicationDeadline: data.postperiod_dt
      ? `${data.postperiod_dt}`
      : undefined,
    caseScore,
    instructorScore,
    salaryScore,
    magnificationScore
  }
}
